import {Component, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'download-information-dialog-component',
    templateUrl: 'download-information-dialog.html',
    styleUrls: ['./extra-information-dialog.scss'],
    imports: [MatIcon, MatButton, RouterLink]
})
export class DownloadInformationDialog {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public dialogRef: MatDialogRef<DownloadInformationDialog>) {
     }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeInfocard() {
    this.dialogRef.close();
  }

}
